module.exports = __webpack_public_path__ + "static/media/nest2.96cca7e5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/flexhouse/nest2.mp4
// module id = 96
// module chunks = 0